import { css } from "@linaria/core";
import { makeSurfaceToken, units, postloadedImageSelectors } from "@pm2/compat";

export const linkSurface = makeSurfaceToken("--slider-link", {
  color: "255 255 255",
  background: "0 0 0 / 0.8",
});

export const wrapper = css`
  position: absolute;
  top: 0;
  left: 0;

  max-height: ${units.px(550)};
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
`;

export const imageCls = css`
  position: absolute;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  & ${postloadedImageSelectors.image()} {
    object-fit: contain;
  }
`;

export const link = css`
  position: absolute;
  right: ${units.px(2 * 10)};
  bottom: ${units.px(4 * 10)};

  padding: 0 ${units.px(1 * 10)};

  height: ${units.px(3 * 10)};

  background: ${linkSurface()};
  border-radius: ${units.px(1.5 * 10)};

  font-size: ${units.font.px(1.6 * 10)};
  line-height: ${units.px(3 * 10)};

  &:hover {
    text-decoration: underline;
  }
`;
